module.exports = __webpack_public_path__ + "static/media/sensor5.b3045457.jpg";